__turbopack_context__.v({
  "contentWraper": "styles-module-scss-module__tMJIgG__contentWraper",
  "previewButton": "styles-module-scss-module__tMJIgG__previewButton",
  "previewImage": "styles-module-scss-module__tMJIgG__previewImage",
  "previewItem": "styles-module-scss-module__tMJIgG__previewItem",
  "previewText": "styles-module-scss-module__tMJIgG__previewText",
});
